<script lang="ts">
    import {onMount} from "svelte";
    import ButtonView from "../common/Button/ButtonView.svelte";
    import {EnvStore} from "../../store/EnvStore";

    let isPressed = false;
    $: envType = EnvStore.type;

    $: isProd = (() => {
        return EnvStore.isProd($envType);
    })();


    $: loginUrl = (() => {
        const currentUrl = location.href;
        const encodeCurrentUrl = encodeURIComponent(currentUrl);
        const loginUrl = `/api/auth/login?redirect_url=${encodeCurrentUrl}`;
        return loginUrl;
    })();

    onMount(() => {

    });

    function onClickLogin() {
        isPressed = true;

        location.assign(loginUrl);
    }

</script>

<div class="login-view">
    <div class="login-area">
        <h1 class="title">ログイン</h1>

        <div class="button-area">
            <ButtonView
                    fontAwesomeIcon="microsoft" fontAwesomeClassification="fab" text="Microsoft でログインする"
                    isProgress={isPressed} on:click={onClickLogin}
                    isPrimary={true}
            />

        </div>


    </div>

</div>
<style lang="scss">
    .login-view {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 24px;

        .login-area {
            text-align: center;

            padding: 48px;

            max-width: 400px;

            .button-area {
                margin-top: 120px;

            }
        }

    }
</style>